import cv from '../cv.js';
import { Card, List, Text, Anchor, Divider, Heading } from 'dracula-ui'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faGitlab, faLinkedin, faMastodon, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faMap } from '@fortawesome/free-regular-svg-icons';

const socialIcons = {
  mastodon: faMastodon,
  twitter: faTwitter,
  linkedin: faLinkedin,
  github: faGithub,
  gitlab: faGitlab
}

function Socials() {
  return(
    <>
      <Card
        variant="subtle"
        p="xs" 
        m="xs" 
        className="drac-border-white drac-text-white">
          <Heading align="center">About</Heading>
          <Divider />
          <List>
            <li 
              className="drac-text drac-text-white">
              <Text size="xs"><FontAwesomeIcon icon={faEnvelope} />{' ' + cv.basics.email}</Text>
            </li>
            <li 
              className="drac-text drac-text-white">
              <Text size="xs"><FontAwesomeIcon icon={faMap} />{
                ' ' + 
                cv.basics.location.city + 
                ', ' + 
                cv.basics.location.countryCode
                }
              </Text>
            </li>
          </List>
      </Card>
      <Card 
        variant="subtle"
        p="xs" 
        m="xs" 
        className="drac-border-white">
        <Heading align="center">Languages</Heading>
        <Divider />
        <List>
          {cv.languages.map((item, index) => (
            <li 
              key={index} 
              className="drac-text drac-text-white">
              <Text size="xs">{item.language + ': ' + item.fluency}</Text>
            </li>
          ))}
        </List>
      </Card>
      <Card 
        variant="subtle"
        p="xs" 
        m="xs" 
        className="drac-border-white">
        <Heading align="center">Skills</Heading>
        <Divider />
        <List>
          {cv.skills.map((item, index) => (
            <li 
              key={index} 
              className="drac-text drac-text-white">
              <Text size="xs">{item.name + ': ' + item.level}</Text>
            </li>
          ))}
        </List>
      </Card>
      <Card 
        variant="subtle"
        p="xs" 
        m="xs" 
        className="drac-border-white">
        <Heading align="center">Socials</Heading>
        <Divider />
        <List>
          {cv.basics.social.map((item, index) => (
            <li 
              key={index} 
              className="drac-text drac-text-white">
                <Text size="xs">
                  <FontAwesomeIcon icon={socialIcons[item.network.toLocaleLowerCase()]}/>
                  {' ' + item.network + ': '} 
                  <Anchor size="xs" href={item.url}>{item.username}</Anchor>
                </Text>
            </li>
          ))}
        </List>
        <Divider />
        <Text align="center" as="p">They can talk about me:</Text>
        <List>
          {cv.references.map((item, index) => (
            <li 
              key={index} 
              className="drac-text drac-text-white">
                <Text size="xs">
                  <Anchor size="xs" href={'mailto:' + item.reference + '?subject=About ' + cv.basics.name}>{item.name}</Anchor>
                </Text>
            </li>
          ))}
        </List>
      </Card>
    </>
  );
}

export default Socials;